"use client"
/* */
import { jsx, jsxs } from 'react/jsx-runtime';
import { useState } from 'react';
import * as Aria from 'react-aria-components';
import formFieldStyles from '../FormField/FormField.module.scss.mjs';
import clsx from 'clsx';
import { ClearPropsContext } from '../ClearPropsContext/ClearPropsContext.mjs';
import '../../lib/propsContext/propsContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { FieldError } from '../FieldError/FieldError.mjs';
import { FieldDescription } from '../FieldDescription/FieldDescription.mjs';
import locales from '../../../../_virtual/_.locale.json@444629885187f8ca5450a1c8b14fb45c.mjs';
import { useLocalizedStringFormatter } from 'react-aria';

const TextFieldBase = (props) => {
  const { children, className, input, showCharacterCount, ref, ...rest } = props;
  const [charactersCount, setCharactersCount] = useState(
    props.value?.length ?? 0
  );
  const rootClassName = clsx(formFieldStyles.formField, className);
  const translation = useLocalizedStringFormatter(locales);
  const propsContext = {
    Label: {
      className: formFieldStyles.label,
      optional: !props.isRequired
    },
    FieldDescription: {
      className: formFieldStyles.fieldDescription
    },
    FieldError: {
      className: formFieldStyles.customFieldError
    }
  };
  const handleOnChange = (v) => {
    if (showCharacterCount) {
      setCharactersCount(v.length);
    }
    if (props.onChange) {
      props.onChange(v);
    }
  };
  const charactersCountDescription = translation.format(
    "textFieldBase.characters",
    {
      count: charactersCount,
      maxCount: props.maxLength ?? 0
    }
  );
  const propsWithOptionalStringValue = "value" in props ? {
    value: props.value ?? ""
  } : {};
  return /* @__PURE__ */ jsx(ClearPropsContext, { children: /* @__PURE__ */ jsxs(
    Aria.TextField,
    {
      ref,
      ...rest,
      className: rootClassName,
      onChange: handleOnChange,
      ...propsWithOptionalStringValue,
      children: [
        input,
        /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children }),
        showCharacterCount && /* @__PURE__ */ jsx(FieldDescription, { className: formFieldStyles.fieldDescription, children: charactersCountDescription }),
        /* @__PURE__ */ jsx(FieldError, { className: formFieldStyles.fieldError })
      ]
    }
  ) });
};

export { TextFieldBase, TextFieldBase as default };
//# sourceMappingURL=TextFieldBase.mjs.map
